import EditableEdge from "./EditableEdge"

export const edgeTypes = {
  default: EditableEdge,
  editable: EditableEdge,
}

export { EditableEdge }
